/* ============================================================
   SMARTCUBES — UX-moduler
   1. Fri fragt-progressbar i kurv (drawer + kurvside)
   2. Farvehukommelse på tværs af sider
   3. Kort og tydeligt leveringsdato-estimat på produktsider
   4. Tilbage-til-toppen på opskriftssiden
   Alle moduler fejler stille — intet her må kunne blokere et køb.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Faelles ---------- */

  function kr(oere) {
    var v = oere / 100;
    return v.toLocaleString('da-DK', { minimumFractionDigits: 2 }).replace(/,00$/, '') + ' kr.';
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function styleOnce(id, css) {
    if (document.getElementById(id)) return;
    var s = document.createElement('style');
    s.id = id;
    s.textContent = css;
    document.head.appendChild(s);
  }

  /* ============================================================
     1. FRI FRAGT-PROGRESSBAR
     ============================================================ */
  (function shippingBar() {
    var THRESHOLD = 29900; // oere
    var EL = 'sc-ship';
    var busy = false;

    var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true">' +
      '<path d="M3 7h13v8H3zM16 10h3l2 3v2h-5"/><circle cx="6.5" cy="17" r="1.6"/><circle cx="17.5" cy="17" r="1.6"/></svg>';
    var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true">' +
      '<path d="M5 12l4 4 10-10"/></svg>';

    function css() {
      styleOnce('sc-ship-style', [
        '.sc-ship{margin:0 0 1.6rem;padding:1.4rem 1.6rem;border:1px solid rgba(42,36,30,.12);',
        'border-radius:14px;background:#F5F0E7;font-family:var(--font-body-family);box-sizing:border-box;',
        'align-self:flex-start;height:auto;min-height:0;box-shadow:0 8px 24px rgba(42,36,30,.04);}',
        '.sc-ship__text{font-size:1.35rem;line-height:1.4;color:#2A241E;margin:0 0 1rem;',
        'display:flex;align-items:center;gap:.8rem;font-weight:500;}',
        '.sc-ship__text svg{width:17px;height:17px;flex:0 0 auto;color:#C9836B;}',
        '.sc-ship__text b{font-weight:600;}',
        '.sc-ship__track{height:6px;border-radius:100px;background:rgba(42,36,30,.10);overflow:hidden;}',
        '.sc-ship__fill{display:block!important;height:100%;border-radius:100px;',
        'background:linear-gradient(90deg,#E3B5A4,#C9836B);width:0;',
        'transition:width .45s cubic-bezier(.23,1,.32,1);}',
        '.sc-ship--done{background:#F3E2DA;border-color:rgba(201,131,107,.35);}',
        '.sc-ship--done .sc-ship__fill{background:linear-gradient(90deg,#C9836B,#A8634C);}',
        '@media screen and (max-width:749px){.sc-ship{padding:1.2rem 1.3rem;margin-bottom:1.2rem;}',
        '.sc-ship__text{font-size:1.25rem;margin-bottom:.8rem;}}',
        '@media (prefers-reduced-motion:reduce){.sc-ship__fill{transition:none;}}'
      ].join(''));
    }

    function targets() {
      var out = [];
      ['cart-drawer .drawer__footer', '#CartDrawer .drawer__footer', '.cart-drawer__footer',
       '#main-cart-footer .cart__footer', '.cart__footer'].forEach(function (q) {
        document.querySelectorAll(q).forEach(function (n) {
          if (out.indexOf(n) === -1) out.push(n);
        });
      });
      return out;
    }

    function paint(total) {
      css();
      var remaining = THRESHOLD - total;
      var done = remaining <= 0;
      var pct = Math.max(0, Math.min(100, (total / THRESHOLD) * 100));

      targets().forEach(function (host) {
        var old = host.querySelector('.' + EL);
        if (total <= 0) { if (old) old.remove(); return; }

        var el = old;
        if (!el) {
          el = document.createElement('div');
          el.className = EL;
          el.innerHTML = '<p class="sc-ship__text"></p><div class="sc-ship__track"><div class="sc-ship__fill"></div></div>';
          host.insertBefore(el, host.firstChild);
        }

        el.classList.toggle('sc-ship--done', done);
        el.querySelector('.sc-ship__text').innerHTML = done
          ? CHECK + '<span><b>Du har fri fragt.</b></span>'
          : TRUCK + '<span>Du mangler <b>' + kr(remaining) + '</b> for at få fri fragt.</span>';

        var fill = el.querySelector('.sc-ship__fill');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { fill.style.width = pct + '%'; });
        });
      });
    }

    function refresh() {
      if (busy) return;
      busy = true;
      var base = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
      fetch(base + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c) paint(c.total_price); })
        .catch(function () {})
        .then(function () { busy = false; });
    }

    var t;
    function debounced() { clearTimeout(t); t = setTimeout(refresh, 120); }

    onReady(function () {
      refresh();
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, debounced);
        }
      } catch (e) {}

      var roots = document.querySelectorAll('cart-drawer, #CartDrawer, #main-cart-footer, cart-items, #main-cart-items');
      if (roots.length) {
        var mo = new MutationObserver(function (muts) {
          for (var i = 0; i < muts.length; i++) {
            var n = muts[i].target;
            if (n && n.closest && n.closest('.' + EL)) continue;
            debounced();
            return;
          }
        });
        roots.forEach(function (r) { mo.observe(r, { childList: true, subtree: true }); });
      }

      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) debounced();
      });
    });
  })();

  /* ============================================================
     2. FARVEHUKOMMELSE
     Husker den valgte farve på tværs af sider. Respekterer altid
     et eksplicit ?variant= i URL'en — den er brugerens klare valg.
     ============================================================ */
  (function colourMemory() {
    var KEY = 'sc:colour';
    var MAXAGE = 1000 * 60 * 60 * 24 * 30; // 30 dage

    function save(v) {
      if (!v) return;
      try {
        localStorage.setItem(KEY, JSON.stringify({ v: v, t: Date.now() }));
      } catch (e) {}
    }

    function load() {
      try {
        var raw = localStorage.getItem(KEY);
        if (!raw) return null;
        var d = JSON.parse(raw);
        if (!d || !d.v) return null;
        if (Date.now() - (d.t || 0) > MAXAGE) return null;
        return d.v;
      } catch (e) { return null; }
    }

    onReady(function () {
      /* Gem ved ethvert farvevalg — produktside, bundle og forside */
      document.addEventListener('click', function (e) {
        var b = e.target.closest(
          '.scp-sw button[data-val], .scb-sw button[data-val], [data-sc-swatches] button[data-color]'
        );
        if (!b) return;
        save(b.dataset.val || b.dataset.color);
      }, { passive: true });

      /* Anvend kun hvis brugeren ikke selv har peget paa en variant */
      if (new URLSearchParams(location.search).has('variant')) return;

      var want = load();
      if (!want) return;

      /* Vent til sektionens egen init har koert */
      requestAnimationFrame(function () {
        var sel = '.scp-sw button[data-val="' + CSS.escape(want) + '"],' +
                  '.scb-sw button[data-val="' + CSS.escape(want) + '"]';
        var btn;
        try { btn = document.querySelector(sel); } catch (e) { return; }
        if (btn && !btn.classList.contains('active')) btn.click();
      });
    });
  })();

  /* ============================================================
     3. KORT OG TYDELIGT LEVERINGSDATO-ESTIMAT
     Viser kun det relevante leveringsvindue på 2-4 hverdage.
     Datoerne beregnes i dansk tid og opdateres automatisk.
     ============================================================ */
  (function deliveryEstimate() {
    var MIN_DELIVERY_DAYS = 2;
    var MAX_DELIVERY_DAYS = 4;
    var TIME_ZONE = 'Europe/Copenhagen';
    var DAYS = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];
    var MONTHS = ['januar', 'februar', 'marts', 'april', 'maj', 'juni',
                  'juli', 'august', 'september', 'oktober', 'november', 'december'];
    var CALENDAR =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" aria-hidden="true">' +
      '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/>' +
      '<path d="M8 14h3M13 14h3M8 17h3"/></svg>';

    function utcDate(y, m, d) {
      return new Date(Date.UTC(y, m, d));
    }

    function addCalendarDays(from, n) {
      var d = new Date(from.getTime());
      d.setUTCDate(d.getUTCDate() + n);
      return d;
    }

    function danishToday() {
      try {
        var parts = new Intl.DateTimeFormat('en-CA', {
          timeZone: TIME_ZONE,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).formatToParts(new Date());
        var values = {};
        parts.forEach(function (part) {
          if (part.type !== 'literal') values[part.type] = part.value;
        });
        return utcDate(Number(values.year), Number(values.month) - 1, Number(values.day));
      } catch (e) {
        var now = new Date();
        return utcDate(now.getFullYear(), now.getMonth(), now.getDate());
      }
    }

    function easterSunday(y) {
      var a = y % 19, b = Math.floor(y / 100), c = y % 100;
      var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
      var g = Math.floor((b - f + 1) / 3);
      var h = (19 * a + b - d - g + 15) % 30;
      var i = Math.floor(c / 4), k = c % 4;
      var l = (32 + 2 * e + 2 * i - h - k) % 7;
      var m = Math.floor((a + 11 * h + 22 * l) / 451);
      var month = Math.floor((h + l - 7 * m + 114) / 31);
      var day = ((h + l - 7 * m + 114) % 31) + 1;
      return utcDate(y, month - 1, day);
    }

    function dateKey(d) {
      return d.getUTCFullYear() + '-' + d.getUTCMonth() + '-' + d.getUTCDate();
    }

    function holidays(y) {
      var out = {};
      function add(d) { out[dateKey(d)] = true; }

      var easter = easterSunday(y);
      add(utcDate(y, 0, 1));
      add(addCalendarDays(easter, -3));
      add(addCalendarDays(easter, -2));
      add(addCalendarDays(easter, 1));
      if (y < 2024) add(addCalendarDays(easter, 26));
      add(addCalendarDays(easter, 39));
      add(addCalendarDays(easter, 50));
      add(utcDate(y, 11, 24));
      add(utcDate(y, 11, 25));
      add(utcDate(y, 11, 26));
      add(utcDate(y, 11, 31));
      return out;
    }

    var holidayCache = {};
    function isClosed(d) {
      var weekday = d.getUTCDay();
      if (weekday === 0 || weekday === 6) return true;
      var y = d.getUTCFullYear();
      if (!holidayCache[y]) holidayCache[y] = holidays(y);
      return !!holidayCache[y][dateKey(d)];
    }

    function addBusinessDays(from, n) {
      var d = new Date(from.getTime());
      while (n > 0) {
        d = addCalendarDays(d, 1);
        if (!isClosed(d)) n--;
      }
      return d;
    }

    function shortDate(d, includeMonth, includeYear) {
      var text = DAYS[d.getUTCDay()] + ' ' + d.getUTCDate() + '.';
      if (includeMonth) text += ' ' + MONTHS[d.getUTCMonth()];
      if (includeYear) text += ' ' + d.getUTCFullYear();
      return text;
    }

    function dateRange(from, to) {
      var sameYear = from.getUTCFullYear() === to.getUTCFullYear();
      var sameMonth = sameYear && from.getUTCMonth() === to.getUTCMonth();
      var text;

      if (sameMonth) {
        text = shortDate(from, false, false) + ' – ' + shortDate(to, true, false);
      } else if (sameYear) {
        text = shortDate(from, true, false) + ' – ' + shortDate(to, true, false);
      } else {
        text = shortDate(from, true, true) + ' – ' + shortDate(to, true, true);
      }
      return text.charAt(0).toUpperCase() + text.slice(1);
    }

    function ensureElement(host) {
      var el = document.querySelector('.sc-eta');
      if (el && document.documentElement.contains(el)) return el;

      el = document.createElement('div');
      el.className = 'sc-eta';
      el.setAttribute('aria-live', 'polite');
      el.innerHTML =
        '<span class="sc-eta__icon">' + CALENDAR + '</span>' +
        '<span class="sc-eta__content">' +
          '<span class="sc-eta__label">Forventet levering</span>' +
          '<strong class="sc-eta__dates"></strong>' +
        '</span>';
      host.parentNode.insertBefore(el, host.nextSibling);
      return el;
    }

    function render() {
      var host = document.querySelector('.scp-strip, .scb-strip');
      if (!host) return;

      var orderDate = danishToday();
      var deliveryFrom = addBusinessDays(orderDate, MIN_DELIVERY_DAYS);
      var deliveryTo = addBusinessDays(orderDate, MAX_DELIVERY_DAYS);
      var key = dateKey(deliveryFrom) + '|' + dateKey(deliveryTo);
      var el = ensureElement(host);

      if (el.dataset.etaKey === key) return;
      el.dataset.etaKey = key;
      el.querySelector('.sc-eta__dates').textContent = dateRange(deliveryFrom, deliveryTo);
    }

    onReady(function () {
      styleOnce('sc-eta-style', [
        '.sc-eta{display:flex;align-items:center;gap:1rem;margin:1.6rem 0 0;padding:1.15rem 1.3rem;',
        'border:1px solid rgba(201,131,107,.42);border-radius:14px;',
        'background:linear-gradient(135deg,#FFF9F4,#F4E5DE);color:#2A241E;',
        'box-shadow:0 10px 26px rgba(79,48,37,.10);box-sizing:border-box;}',
        '.sc-eta__icon{width:3.6rem;height:3.6rem;border-radius:10px;background:#EBCFC4;',
        'display:grid;place-items:center;flex:0 0 auto;color:#9D563F;}',
        '.sc-eta__icon svg{display:block;width:19px;height:19px;}',
        '.sc-eta__content{display:flex;flex-direction:column;gap:.15rem;min-width:0;}',
        '.sc-eta__label{font-size:1.05rem;line-height:1.2;letter-spacing:.055em;text-transform:uppercase;',
        'color:#7B574B;font-weight:700;}',
        '.sc-eta__dates{font-size:1.4rem;line-height:1.35;color:#2A241E;font-weight:700;}',
        '@media screen and (max-width:749px){.sc-eta{padding:1.05rem 1.1rem;gap:.85rem;}',
        '.sc-eta__icon{width:3.3rem;height:3.3rem;}.sc-eta__dates{font-size:1.3rem;}}'
      ].join(''));

      render();
      window.setInterval(render, 60000);
      window.addEventListener('pageshow', render);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) render();
      });
      document.addEventListener('shopify:section:load', render);
    });
  })();

  /* ============================================================
     4. TILBAGE TIL TOPPEN — kun paa opskriftssiden
     ============================================================ */
  (function backToTop() {
    onReady(function () {
      if (!/\/pages\/opskrifter/i.test(location.pathname)) return;

      styleOnce('sc-top-style', [
        '.sc-top{position:fixed;right:1.6rem;bottom:1.6rem;',
        'bottom:calc(1.6rem + env(safe-area-inset-bottom));',
        'z-index:50;width:4.8rem;height:4.8rem;border-radius:50%;border:none;cursor:pointer;',
        'background:#241E18;color:#FBF6EE;display:grid;place-items:center;',
        'box-shadow:0 12px 30px -12px rgba(42,36,30,.6);',
        'opacity:0;visibility:hidden;transform:translateY(12px) scale(.9);',
        'transition:opacity .25s cubic-bezier(.23,1,.32,1),transform .25s cubic-bezier(.23,1,.32,1),visibility .25s;}',
        '.sc-top.is-on{opacity:1;visibility:visible;transform:none;}',
        '.sc-top:active{transform:scale(.92);transition-duration:110ms;}',
        '.sc-top svg{width:2rem;height:2rem;}',
        '@media (prefers-reduced-motion:reduce){.sc-top{transition:opacity .01ms;}}'
      ].join(''));

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sc-top';
      btn.setAttribute('aria-label', 'Tilbage til toppen');
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 19V5M6 11l6-6 6 6"/></svg>';
      document.body.appendChild(btn);

      btn.addEventListener('click', function () {
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      });

      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          btn.classList.toggle('is-on', window.scrollY > 800);
          ticking = false;
        });
      }, { passive: true });
    });
  })();
})();
